import styled, { StyledProps } from 'styled-components/macro';

export type InputProps = StyledProps<{
  size: string;
  error: boolean;
  clear: boolean;
  icon: boolean;
}>;

const heightSize: any = {
  sm: '23px',
  md: '30px',
  lg: '30px',
};

export const Input = styled.div<InputProps>`
  position: relative;
  input {
    height: ${(props) => heightSize[props.size] || '30px'};
    width: 100%;
    background: #ffffff;
    border: 1px solid ${(props) => (props.error ? '#F9585F' : '#C3CFD9')};
    box-sizing: border-box;
    border-radius: 3px;
    padding-left: ${(props) => (props.icon ? '25px' : '7px')};
    padding-right: ${(props) => (props.clear ? '23px' : '7px')};
    color: #1d1e25;
    font-size: 14px;
    ${(props) =>
      props.error
        ? 'box-shadow: 2px 2px 0px #FFD6D7, -2px 2px 0px #FFD6D7, 2px -2px 0px #FFD6D7, -2px -2px 0px #FFD6D7, inset 0px 2px 2px rgba(0, 0, 0, 0.08)'
        : ''};

    &:focus {
      outline: none;
    }

    &::placeholder {
      color: rgb(128, 128, 128);
      font-size: 12px;
    }
  }
`;

export const Label = styled.div`
  font-size: 12px;
  line-height: 15px;
  color: #333333;
  margin-bottom: 2px;
  span {
    color: #cf4845;
    margin-right: 3px;
  }
`;

export const ErrorMessage = styled.div`
  position: absolute;
  bottom: -17px;
  left: 0;
  color: #cf4845;
  font-size: 12px;
  white-space: nowrap;
`;

export const Icon = styled.div`
  position: absolute;
  top: 100%;
  transform: translateY(calc(-50% - 15px));
  left: 10px;
`;

export const Clear = styled.div`
  position: absolute;
  top: 100%;
  transform: translateY(calc(-50% - 15px));
  right: 10px;
  width: 8px;
`;
